<template>
  <v-row class="pb-2">
    <v-col
      cols="4"
      class="py-0"
    >
      <v-select
        v-model="ruleField"
        :label="$t('label.contact_filter_property')"
        :items="ruleFieldsInfo"
        :error-messages="errorMessages"
        :disabled="disabled"
        :append-outer-icon="ruleField !== '' && lastRow ? 'mdi-close' : ''"
        @click:append-outer="ruleField = null; ruleFieldChanged()"
        @input="ruleFieldChanged"
      />
    </v-col>
    <v-col
      cols="3"
      class="py-0"
    >
      <v-select
        v-model="ruleType"
        :disabled="disabled || ruleTypesInfo.length < 1"
        :items="ruleTypesInfo"
        @input="ruleTypeChanged"
      />
    </v-col>
    <v-col
      cols="5"
      class="d-flex justify-center py-0"
    >
      <div
        v-if="isOperand"
        class="w-100"
      >
        <v-select
          v-if="ruleOperandsInfo.length > 0"
          v-model="ruleOperand"
          :disabled="disabled"
          :label="$t('label.contact_filter_property_value')"
          :items="ruleOperandsInfo"
          @input="ruleOperandChanged"
        />
        <v-text-field
          v-else-if="ruleOperandType === 'number'"
          v-model.number="ruleOperand"
          :disabled="disabled"
          :label="$t('label.contact_filter_property_value')"
          type="number"
          @change="ruleOperandChanged"
        />
        <v-text-field
          v-else
          v-model="ruleOperand"
          :disabled="disabled"
          :label="$t('label.contact_filter_property_value')"
          @change="ruleOperandChanged"
        />
      </div>
      <v-spacer />
      <template v-if="!disabled">
        <v-btn
          v-if="lastRow"
          class="align-self-center"
          icon
          :disabled="ruleField === ''"
          @click="add"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
        <v-btn
          v-else
          class="align-self-center"
          icon
          :disabled="disabled"
          @click="remove"
        >
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-col>
  </v-row>
</template>

<script lang="ts">
import {} from '@/services/filter/filter';
import {
  FilterDescriptor, FilterRuleDescriptor, FilterSpecialCategoryOperandType, ListInfo,
} from '@/services/filter/filter-descriptor';
import {
  FilterFieldRule, FilterFieldType, FilterRule, FilterRuleType,
} from '@/services/filter/filter-rule';
import { FilterOperandType } from '@/services/filter/filter-rule-operation';
import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'ContactsFilterValueRow',
  components: { },
  mixins: [],
  props: {
    value: { type: Object as PropType<FilterFieldRule>, required: true },
    descriptor: { type: Object as PropType<FilterDescriptor>, required: true },
    lastRow: { type: Boolean, required: true, default: false },
    errorMessages: { type: Array as PropType<Array<String>>, required: false, default: () => [] },
    disabled: { type: Boolean as PropType<boolean>, required: false, default: false },
  },
  data() {
    return {
      ruleField: null as string | null,
      ruleType: null as FilterRuleType | null,
      ruleOperand: null as FilterOperandType | null,
      ruleDescriptor: null as FilterRuleDescriptor | null,
    };
  },
  computed: {
    ruleFieldsInfo(): ListInfo<string> {
      return this.descriptor.allowedFieldsInfo();
    },
    ruleTypesInfo(): ListInfo<FilterRuleType> {
      return this.ruleDescriptor?.allowedRuleTypesInfo() ?? [];
    },
    isOperand(): boolean {
      return !FilterRule.isFilterFieldNoOperandType(this.value.type);
    },
    ruleOperandsInfo(): ListInfo<FilterOperandType> {
      const type = this.ruleDescriptor?.specialCategoryOperandsType() ?? 'none';
      switch (type) {
        case FilterSpecialCategoryOperandType.Country: return this.$tstore.getters.sortedCountries;
        case FilterSpecialCategoryOperandType.Language: return this.$tstore.getters.sortedLocales;
        default:
      }

      return this.ruleDescriptor?.allowedOperandsInfo() ?? [];
    },
    ruleOperandType(): string {
      if (this.ruleDescriptor?.fieldtype === FilterFieldType.Number) return 'number';
      return 'string';
    },
    rule(): FilterFieldRule {
      const rule = new FilterFieldRule();
      rule.id = this.value.id;
      rule.field = this.ruleDescriptor?.field ?? '';
      rule.fieldType = this.ruleDescriptor?.fieldtype ?? FilterFieldType.None;
      rule.type = this.ruleType ?? FilterRuleType.None;
      rule.operand = this.ruleOperand ?? null;
      return rule;
    },
  },
  watch: {
    value(value: FilterRule) {
      this.reset();
    },
  },
  mounted() {
    this.reset();
    this.ruleFieldChanged();
  },
  methods: {
    reset() {
      this.ruleField = this.value.field;
      this.ruleType = this.value.type;
      this.ruleOperand = this.value.operand;
    },
    add() {
      this.$emit('add');
    },
    remove() {
      this.$emit('remove');
    },
    ruleFieldChanged() {
      this.ruleDescriptor = this.descriptor.ruleDescriptors.find((rd) => rd.field === this.ruleField) ?? null;
      if (!this.ruleDescriptor?.allowedRuleTypes.includes(this.value.type)) {
        this.ruleType = this.ruleDescriptor?.allowedRuleTypes.find(Boolean) ?? null;
      }
      if (this.ruleOperand && this.ruleDescriptor?.validateOperand(this.rule) !== null) {
        this.ruleOperand = null;
      }
      this.$emit('input', this.rule);
    },
    ruleTypeChanged() {
      if (this.ruleOperand && this.ruleDescriptor?.validateOperand(this.rule) !== null) {
        this.ruleOperand = null;
      }
      this.$emit('input', this.rule);
    },
    ruleOperandChanged() {
      this.$emit('input', this.rule);
    },
  },
});
</script>

<style scoped>

</style>
